<script src="../../country.js"></script>
<template>
    <div>
        <div class="cover-layer"></div>
        <div class="country" ref="country">
            <div class="search">
                <input class="room-count" type="text" placeholder="模糊搜索" @input="searchInput('search')" v-model="countryInput">
            </div>
            <ul v-if="!isSearch">
                <li class="title">常用国家/地区</li>
                <li v-for="(val,index) in countryList.freCountry" :title="val.CNName" @click="CountryCheck(val)">
                    {{val.CNName}}
                </li>
                <li class="title">所有国家/地区 (A-Z)</li>
                <li v-for="(val,index) in countryList.country" :title="val.CNName" @click="CountryCheck(val)">
                    {{val.CNName}}
                </li>
            </ul>
            <ul v-if="isSearch">
                <li v-for="(val,index) in countryListAll" :title="val.CNName" @click="CountryCheck(val)">
                    {{val.CNName}}
                </li>
                <li v-if="countryListAll.length==0">无</li>
            </ul>
        </div>
    </div>
</template>

<script>
    const country = require('./../../country.js')
    export default {
        name: "country",
        props: {
            isCountryShow: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                countryList: country,
                countryListAll:country.country,
                isSearch:false,
                countryInput:'',
            }
        },
        watch:{
            countryInput(val){
                if(val == ''){
                    this.isSearch = false;
                }else{
                    this.isSearch = true;
                }
            }
        },
        mounted() {
            this.addCloseListener();
            this.searchInput('init');
        },
        methods: {
            searchInput(type){
                var that = this;
                var params = {}
                if(type == 'init'){
                    params = {}
                }else{
                    params = {
                        q: that.countryInput
                    }
                }
                that.getRequest({
                    url: that.Api.getCountry,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess) {
                        if(type == 'init'){
                            that.countryList.country = res.Result
                            that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                    that.$zh_tran(localStorage.getItem('lang'))
                                }    
                            })
                        }else{
                            that.countryListAll = res.Result;
                            that.$nextTick(() => {
                                if(localStorage.getItem('lang')=='t'){
                                    that.$zh_tran(localStorage.getItem('lang'))
                                }    
                            })
                        }
                    }
                });
            },
            CountryCheck(obj) {
                this.$emit('select', obj);
            },
            addCloseListener() {
                let that = this;
                document.addEventListener('click', that.onClick, false);
            },
            onClick(e) {
                if (e.target.className == 'room-count' || this.$refs.country && this.$refs.country.contains(e.target)) return;
                this.$emit('select')
            }
        },
        destroyed() {
            document.removeEventListener('click', this.onClick, false)
        },
    }
</script>

<style scoped>
    .country {
        position: absolute;
        top: 49px;
        left: -1px;
        width: 170px;
        border: 1px solid #e6e6e6;
        background: #FFF;
        z-index: 2;
    }

    .country .search {
        border-bottom: 1px solid #e6e6e6;
        height: 36px;
        padding: 3px 0;
    }

    .country .title {
        background: #f2f6f9;
        margin: 0;
        font-size: 14px;
    }

    .country .search .room-count {
        padding: 0px 10px;
        height: 30px;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        width: 168px !important;
    }

    .country ul {
        max-height: 300px;
        overflow-y: auto;
    }

    .country li {
        padding: 0 10px;
        width: 100%;
        overflow: hidden;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
    }

    .country li:hover {
        color: #fff;
        background: #00a0e9;
    }

    .country .title:hover {
        background: #f2f6f9;
        color: #333;
        cursor: initial;
    }
</style>


// WEBPACK FOOTER //
// src/common/cmpnt/country/country.vue